export default __webpack_public_path__ + "static/media/dooh_asap.bf5cb69a.svg";